import {defineMessages} from 'react-intl';

const commonMessages = defineMessages({
  add: {
    id: 'CommonMessages.add',
    defaultMessage: 'Add',
  },
  cancel: {
    id: 'CommonMessages.cancel',
    defaultMessage: 'Cancel',
  },
  create: {
    id: 'CommonMessages.create',
    defaultMessage: 'Create',
  },
  delete: {
    id: 'CommonMessages.delete',
    defaultMessage: 'Delete',
  },
  disable: {
    id: 'CommonMessages.disable',
    defaultMessage: 'Disable',
  },
  disabled: {
    id: 'CommonMessages.disabled',
    defaultMessage: 'Disabled',
  },
  edit: {
    id: 'CommonMessages.edit',
    defaultMessage: 'Edit',
  },
  email: {
    id: 'CommonMessages.email',
    defaultMessage: 'Email',
  },
  enable: {
    id: 'CommonMessages.enable',
    defaultMessage: 'Enable',
  },
  enabled: {
    id: 'CommonMessages.enabled',
    defaultMessage: 'Enabled',
  },
  ok: {
    id: 'CommonMessages.ok',
    defaultMessage: 'OK',
  },
  no: {
    id: 'CommonMessages.no',
    defaultMessage: 'No',
  },
  organization: {
    id: 'CommonMessages.organization',
    defaultMessage: 'Organization',
  },
  organizations: {
    id: 'CommonMessages.organizations',
    defaultMessage: 'Organizations',
  },
  proceed: {
    id: 'CommonMessages.proceed',
    defaultMessage: 'Proceed',
  },
  save: {
    id: 'CommonMessages.save',
    defaultMessage: 'Save',
  },
  submit: {
    id: 'CommonMessages.submit',
    defaultMessage: 'Submit',
  },
  warning: {
    id: 'CommonMessages.warning',
    defaultMessage: 'Warning',
  },
  yes: {
    id: 'CommonMessages.yes',
    defaultMessage: 'Yes',
  },
});

export default commonMessages;
